import _ from 'underscore';
import DataTables from './dataTables.js';
import View from '../view.js';

export default class DataTableIniter extends View {
  initialize() {
    this.dom = {
      DATATABLES: '.io-table',
    };
    this.opts = {
      filter: true,
      title: 'Click to edit',
    };
  }

  _ensureDefaultElement() {
    this._setElement('#main-content');
  }

  destroy() {
    if (_.isFunction(this.onDestroy)) {
      this.onDestroy();
    }
    this.off();
    this.stopListening();
    this.remove();
  }

  onDestroy() {
    this._mapCallback(this.dataTables, (el) => el.remove());

    this._mapCallback(this.updateChannels, (el) => Messenger.unsubscribe(el));
  }

  error() {
    this.render();
  }

  beforeRender() {
    this.dataTables = [];
    this.updateChannels = [];
  }

  render() {
    let rawTables = this.$el.find(this.dom.DATATABLES);

    for (let i = rawTables.length - 1; i >= 0; i--) {
      this._setupDatatable($(rawTables[i]));
    }
  }

  _setupDatatable(rawTable) {
    if (rawTable.attr('id') === undefined) {
      rawTable.attr('id', this._getUUID());
    }

    let tableData = rawTable.data(),
      listenTo = tableData.listenTo,
      dataTable;

    delete tableData.listenTo;

    tableData.el = $('#' + rawTable.attr('id'));
    dataTable = new DataTables(
      this._parseOpts($.extend({}, this.opts, tableData)),
    );

    this.dataTables.push(dataTable);
    dataTable.start();

    if (listenTo != undefined) {
      Messenger.on(`/${currentCustomer}/${listenTo}`, () => dataTable.reload());
    }
  }

  _getUUID() {
    // RFC4122 version 4 compliant solution
    var date = new Date().getTime(),
      uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(
        /[xy]/g,
        function (c) {
          let random = ((date + Math.random() * 16) % 16) | 0;

          date = Math.floor(date / 16);

          return (c == 'x' ? random : (random & 0x3) | 0x8).toString(16);
        },
      );

    return uuid;
  }

  _parseOpts(opts) {
    if (opts.columns === undefined) {
      opts.columns = window.da_grid_columns;
    } else {
      opts.columns = window[opts.columns];
    }

    return opts;
  }

  _mapCallback(list, callback) {
    if (!Array.isArray(list)) {
      return;
    }

    for (const element of list) {
      callback(element);
    }
  }
}
